import React, { useState } from 'react';

const navLinks = [
  { name: 'About', href: '#about' },
  { name: 'Work', href: '#work' },
  { name: 'Writing', href: '#portfolio' },
  { name: 'Photography', href: '#portfolio' },
  { name: 'Contact', href: '#contact' },
];

const scrollTo = (href, close) => {
  close?.();
  const el = document.querySelector(href);
  if (!el) return;
  const isMobile = window.innerWidth < 768;
  if (isMobile) {
    window.scrollTo({ top: Math.max(0, el.offsetTop - 48), behavior: 'auto' });
  } else {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
};

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav
      style={{ borderBottom: '0.5px solid #e0ddd8' }}
      className="sticky top-0 z-50 bg-bg-primary flex items-center justify-between px-10 py-5"
    >
      <span
        className="font-playfair text-ink cursor-pointer"
        style={{ fontSize: '15px', letterSpacing: '0.02em' }}
        onClick={() => scrollTo('#home')}
      >
        Manal Khan
      </span>

      {/* Desktop links */}
      <div className="hidden md:flex gap-8">
        {navLinks.map((link) => (
          <button
            key={link.name}
            onClick={() => scrollTo(link.href)}
            className="font-inter text-muted hover:text-ink transition-colors duration-200 cursor-pointer bg-transparent border-none p-0"
            style={{ fontSize: '12px', letterSpacing: '0.12em', textTransform: 'uppercase' }}
          >
            {link.name}
          </button>
        ))}
      </div>

      {/* Mobile hamburger */}
      <button
        className="md:hidden text-muted hover:text-ink p-1 bg-transparent border-none cursor-pointer"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle menu"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d={isOpen ? 'M6 18L18 6M6 6l12 12' : 'M4 6h16M4 12h16M4 18h16'} />
        </svg>
      </button>

      {/* Mobile menu */}
      {isOpen && (
        <div
          className="absolute top-full left-0 right-0 bg-bg-primary flex flex-col py-4"
          style={{ borderBottom: '0.5px solid #e0ddd8' }}
        >
          {navLinks.map((link) => (
            <button
              key={link.name}
              onClick={() => scrollTo(link.href, () => setIsOpen(false))}
              className="text-left px-10 py-3 text-muted hover:text-ink transition-colors duration-200 bg-transparent border-none cursor-pointer font-inter"
              style={{ fontSize: '12px', letterSpacing: '0.12em', textTransform: 'uppercase' }}
            >
              {link.name}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
